var map = {
	"./bad-connection.svg": "0ecb",
	"./clock.svg": "8db1",
	"./disconnected.svg": "4e46",
	"./done.svg": "cb2f",
	"./empty-box.svg": "d28d",
	"./face-recognition-error.svg": "0a81",
	"./face-recognition.svg": "b6e8",
	"./fingerprint.svg": "0a7c",
	"./location-error.svg": "b4ae",
	"./no-camera.svg": "3f25",
	"./safe.svg": "5177",
	"./something-went-wrong.svg": "1ee3",
	"./twofactorauth.svg": "842c",
	"./verification-check.svg": "3cf4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5b6";